// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerContentHelper from "./PartnerContentHelper.bs.js";

function getContent(vehicle_category, geo_region) {
  if (vehicle_category !== 0) {
    return {
            title_text: "कम्पलीशन स्कोअर",
            learn_more_text: "अधिक जाणून घ्या",
            info_btn_details: {
              video_url: undefined,
              question: "कम्पलीशन स्कोअर म्हणजे काय?",
              answer: "आपल्याला नेमून दिलेल्या शेवटच्या 50 ऑर्डरमध्ये पूर्ण झालेल्या एकूण ऑर्डर म्हणून कम्पलीशन स्कोअर मोजला जातो. \n\n                                  उदा: पोर्टरने 50 ऑर्डर दिल्यास आणि तुम्ही 40 पूर्ण केल्यास, कम्पलीशन स्कोअर 80% असेल"
            },
            learn_more_btn_details: [
              {
                video_url: PartnerContentHelper.getV1InfoVidTrucks(geo_region),
                question: "कम्पलीशन स्कोअर म्हणजे काय आणि ते महत्त्वाचे का आहे?",
                answer: ""
              },
              {
                video_url: undefined,
                question: "मी माझा कम्पलीशन स्कोअर कसा सुधारू शकतो?",
                answer: "उच्च कम्पलीशन स्कोअर राखण्यासाठी सर्व ऑर्डर स्वीकारा आणि पूर्ण करा"
              },
              {
                video_url: undefined,
                question: "चांगला कम्पलीशन स्कोअर म्हणजे काय ?",
                answer: "सर्वाधिक कमाई करणारे पोर्टर पार्टनर   90% किंवा त्याहून अधिक कम्पलीशन स्कोअर राखतात."
              },
              {
                video_url: undefined,
                question: "मी माझा कम्पलीशन स्कोअर का पाहू शकत नाही?",
                answer: "ज्या पार्टनरांना किमान 50 ऑर्डर मिळाल्या आहेत त्यांचा च स्कोअर मोजला जातो."
              }
            ],
            locked_score_msg: "स्कोअर अनलॉक करण्यासाठी आणखी ऑर्डर स्वीकारा",
            message_text: "उच्च कम्पलीशन स्कोअर असलेल्या पार्टनरांना ला अधिक ऑर्डर मिळण्याची शक्यता जास्त असते."
          };
  } else {
    return {
            title_text: "कम्पलीशन स्कोअर",
            learn_more_text: "अधिक जाणून घ्या",
            info_btn_details: {
              video_url: undefined,
              question: "कम्पलीशन स्कोअर म्हणजे काय?",
              answer: "कम्पलीशन स्कोरची गणना तुम्हाला नियुक्त केलेल्या शेवटच्या 50 ऑर्डरमध्ये पूर्ण केलेल्या ऑर्डर म्हणून केली जाते. ऑर्डर तुम्हाला पिंग केल्या परंतु तुमच्या पूर्वी दुसऱ्या भागीदाराने स्वीकारल्या ऑर्डर तुमच्या स्कोरमध्ये गणल्या नाही जात \n\n                    उदाहरण : जर पोर्टरने 50 ऑर्डर दिल्या आणि तुम्ही 40 पूर्ण केले, तर कम्पलीशन स्कोर 80% आहे"
            },
            learn_more_btn_details: [
              {
                video_url: PartnerContentHelper.getV1InfoVid2w(geo_region),
                question: "कम्पलीशन स्कोअर म्हणजे काय आणि ते महत्त्वाचे का आहे?",
                answer: ""
              },
              {
                video_url: undefined,
                question: "मी माझा कम्पलीशन स्कोअर कसा सुधारू शकतो?",
                answer: "उच्च कम्पलीशन स्कोअर राखण्यासाठी सर्व ऑर्डर स्वीकारा आणि पूर्ण करा"
              },
              {
                video_url: undefined,
                question: "चांगला कम्पलीशन स्कोअर म्हणजे काय ?",
                answer: "सर्वाधिक कमाई करणारे पोर्टर पार्टनर   90% किंवा त्याहून अधिक कम्पलीशन स्कोअर राखतात."
              },
              {
                video_url: undefined,
                question: "मी माझा कम्पलीशन स्कोअर का पाहू शकत नाही?",
                answer: "ज्या पार्टनरांना किमान 50 ऑर्डर मिळाल्या आहेत त्यांचा च स्कोअर मोजला जातो."
              }
            ],
            locked_score_msg: "स्कोअर अनलॉक करण्यासाठी आणखी ऑर्डर स्वीकारा",
            message_text: "उच्च कम्पलीशन स्कोअर असलेल्या पार्टनरांना ला अधिक ऑर्डर मिळण्याची शक्यता जास्त असते."
          };
  }
}

export {
  getContent ,
  
}
/* No side effect */
